import { CreditCard, MailOpen, MonitorPlay } from "lucide-react";
import { SectionHead, Reveal } from "./Reveal";

const STEPS = [
  { n: "01", title: "Register", desc: "Complete your ₹199 bootcamp payment.", Icon: CreditCard },
  { n: "02", title: "Get Access", desc: "Receive joining instructions and community details.", Icon: MailOpen },
  { n: "03", title: "Attend Live", desc: "Join both sessions and follow the practical training.", Icon: MonitorPlay },
];

export default function HowItWorks() {
  return (
    <section id="how" data-testid="how-section" className="bg-white py-20 sm:py-28">
      <div className="mx-auto max-w-5xl px-5 sm:px-8">
        <SectionHead
          eyebrow="How It Works"
          title={<>Getting Started Is <span className="bg-gradient-to-r from-[#9B5CF0] to-[#6D28D9] bg-clip-text text-transparent">Simple.</span></>}
          testId="how"
        />
        <div className="relative mt-14">
          <div className="pointer-events-none absolute left-0 right-0 top-16 hidden border-t-2 border-dashed border-[#E9DFFC] lg:block" />
          <div className="grid gap-6 sm:grid-cols-3">
            {STEPS.map((s, i) => (
              <Reveal key={s.n} delay={0.15 * i}>
                <div
                  data-testid={`how-step-${i}`}
                  className="group relative h-full rounded-3xl border border-[#E9DFFC] bg-white p-7 text-center transition-[transform,border-color,box-shadow] duration-300 hover:-translate-y-1.5 hover:border-[#7C3AED]/40 hover:shadow-[0_25px_50px_-20px_rgba(124,58,237,0.25)]"
                >
                  <span className="relative mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-br from-[#9B5CF0] to-[#6D28D9] text-white shadow-[0_12px_25px_-8px_rgba(124,58,237,0.6)]">
                    <s.Icon size={24} />
                    <span className="absolute -right-1.5 -top-1.5 flex h-6 w-6 items-center justify-center rounded-full bg-[#171321] font-mono text-[10px] font-bold text-white">
                      {s.n}
                    </span>
                  </span>
                  <h3 className="mt-5 text-lg font-extrabold tracking-tight text-[#171321]">{s.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-[#777181]">{s.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
